import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isSaudiBrand } from '../../products/saudi/utils/isSaudiBrand';
import EmployeePortalProfilePage from './EmployeePortalProfilePage';
import EmployeePortalLeavesPage from './EmployeePortalLeavesPage';
import EmployeePortalContractsPage from './EmployeePortalContractsPage';
import EmployeePortalDocumentsPage from './EmployeePortalDocumentsPage';
import EmployeePortalTrainingPage from './EmployeePortalTrainingPage';
import EmployeePortalPerformancePage from './EmployeePortalPerformancePage';
import EmployeePortalServiceRequestsPage from './EmployeePortalServiceRequestsPage';
import EmployeePortalAnnouncementsPage from './EmployeePortalAnnouncementsPage';
import EmployeePortalAccountPage from './EmployeePortalAccountPage';
import EmployeePortalAnalysesPage from './EmployeePortalAnalysesPage';
import EmployeePortalDashboardPage from './EmployeePortalDashboardPage';
import { PortalEmployeeProvider } from './PortalEmployeeContext';

const EmployeePortalMainPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.employee_portal.pages.employeePortalMainPage.${key}`, opts);
  const brandLabel = isSaudiBrand() ? p('subtitle') : p('title');

  return (
    <PortalEmployeeProvider>
    <div aria-label={p('title')} data-brand={isSaudiBrand() ? 'saudi' : 'legacy'}>
      <span className="sr-only">{brandLabel}</span>
      <Routes>
        <Route path="/" element={<Navigate to="/employee-portal/dashboard" replace />} />
        <Route path="/dashboard" element={<EmployeePortalDashboardPage />} />
        <Route path="/profile" element={<EmployeePortalProfilePage />} />
        <Route path="/leaves" element={<EmployeePortalLeavesPage />} />
        <Route path="/contracts" element={<EmployeePortalContractsPage />} />
        <Route path="/documents" element={<EmployeePortalDocumentsPage />} />
        <Route path="/training" element={<EmployeePortalTrainingPage />} />
        <Route path="/performance" element={<EmployeePortalPerformancePage />} />
        <Route path="/service-requests" element={<EmployeePortalServiceRequestsPage />} />
        <Route path="/announcements" element={<EmployeePortalAnnouncementsPage />} />
        <Route path="/account" element={<EmployeePortalAccountPage />} />
        <Route path="/analyses-rapports" element={<EmployeePortalAnalysesPage />} />
        <Route path="/*" element={<Navigate to="/employee-portal/dashboard" replace />} />
      </Routes>
    </div>
    </PortalEmployeeProvider>
  );
};

export default EmployeePortalMainPage;
